interface ReportRequestData {
    filter: any;
    timestamp: number;
}

// Salva o filtro e o momento atual no localStorage para um relatório específico
export function saveReportRequest(reportId: string, filter: any): void {
    const data: ReportRequestData = {
        filter,
        timestamp: Date.now(),
    };
    localStorage.setItem(`reportRequest:${reportId}`, JSON.stringify(data));
}

// Valida se já se passaram mais de 10 minutos desde a última solicitação para um relatório específico
// ou se o filtro é diferente do último salvo
export function isReportRequestExpired(reportId: string, filter: any): boolean {
    const dataStr = localStorage.getItem(`reportRequest:${reportId}`);
    if (!dataStr) return false;
    try {
        const data: ReportRequestData = JSON.parse(dataStr);
        // Se o filtro for diferente, pode passar (não está expirado para esse filtro)
        if (JSON.stringify(data.filter) !== JSON.stringify(filter)) {
            return false;
        }
        const TEN_MINUTES = 10 * 60 * 1000;
        return (Date.now() - data.timestamp) < TEN_MINUTES;
    } catch {
        return false;
    }
}
